import React from 'react';
import Divider from '@material-ui/core/Divider';
import './style.css';
import {Link} from 'react-scroll';

class Intro extends React.Component {

	render() {
		return (
			<div
				id="home"
				className="intro route bg-image back"
			>
				<div className="intro-content display-table">
					<div className="table-cell">
						<div className="backStyle">
							<h1 className="title">{this.props.title}</h1>
							<div>
								<Divider />
							</div>
							{/* <h2 className="subtitle_large">
								{this.props.subtitle}
							</h2> */}
							<h2 className="italicIntro" dangerouslySetInnerHTML={{ __html: this.props.contents }} />
							{this.props.tag ? <span className='spanElementTag elementTag'> 
								<h2 className='elementTag'>
									notaio e {this.props.title};
								</h2>
								<h2 className='elementTag'>
									{this.props.title} a Treviso e provincia;
								</h2>
								{this.props.tag.map( element => {
								return (
									<h2 key={element} className='elementTag'>
										{element};
									</h2>
								);
								}
								)}
								<h2 className='elementTag'>
									{this.props.title} Veneto;
								</h2>
								<h2 className='elementTag'>
									{this.props.title} preventivo;
								</h2>
							</span> : null}
							<p className="pt-3 onScrollB">
								<Link to={this.props.linkSpinner} spy={true} smooth={true}>
									<div className="spinner scroll-down"> 
										<a className="animate" /> 
									</div>
								</Link>
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Intro;
